import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useLabels } from 'wsm-common-data';
import PaymentSelector from './PaymentSelector';
import SpecialsDisplay from './SpecialsDisplay';
import StepCtas from './StepCtas';
import useUdsLeadGate from '../hooks/useUdsLeadGate';
import { UDS_LEAD_GATE, UDS_LEAD_GATE_ANCHOR } from '../constants';

import './PaymentSelector.scss';

const UdsLeadGateOverlay = ({ text = '' }) => (
	<div className="payment-unavailable">
		<div className="payment-unavailable-content">
			<p className="payment-unavailable-title">
				<a
					href={UDS_LEAD_GATE_ANCHOR}
					aria-label={text}
					role="button"
				>
					{text}
				</a>
			</p>
		</div>
	</div>
);

const PaymentSelectorView = () => {
	const labels = useLabels();
	const { enableIncentives, showCTAs } = usePrefs();
	const isLeadGateActive = useUdsLeadGate()

	return (
		<>{isLeadGateActive
			?
				<UdsLeadGateOverlay text={labels.get(UDS_LEAD_GATE)} />
			:
				<>
					<PaymentSelector key="track-my-offer-payment-selector" />
					{enableIncentives === 'true' && (
						<SpecialsDisplay key="track-my-offer-specials-display" />
					)}
					{showCTAs === 'true' && <StepCtas key="track-my-offer-ctas" />}
				</>}
		</>
	);
};


UdsLeadGateOverlay.propTypes = {
	text: PropTypes.string
};

export default PaymentSelectorView;